<div class="card" *ngIf="jobList">
	<p-table
		#dt
		styleClass="p-datatable-responsive-demo"
		[value]="automaticEmployeeMessageList"
		[loading]="!automaticEmployeeMessageList"
		[globalFilterFields]="app.keys(automaticEmployeeMessageList)"
		[rowHover]="true"
		[rows]="10"
		[showCurrentPageReport]="true"
		[rowsPerPageOptions]="[10, 25, 50]"
		responsiveLayout="scroll"
		[paginator]="true"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} recordName"
	>
		<ng-template pTemplate="caption">
			<div class="table-header d-flex">
				<div class="flex-grow-1">
					<span class="p-float-label p-input-icon-left m-2 w-100">
						<i class="pi pi-search"></i>
						<input
							pInputText
							class="w-100"
							id="globalSearch"
							name="globalSearch"
							style="width: 100%"
							type="text"
							(input)="dt.filterGlobal($event.target.value, 'contains')"
						/>
						<label for="globalSearch">Search...</label>
					</span>
				</div>
			</div>
		</ng-template>
		<ng-template pTemplate="header">
			<tr>
				<th pSortableColumn="subjectEngligh">
					<div class="d-flex w-100">
						Subject
						<p-sortIcon field="subjectEngligh"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="text" field="subjectEngligh" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="jobName">
					<div class="d-flex w-100">
						Job
						<p-sortIcon field="jobId"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter
								field="jobId"
								matchMode="equals"
								display="menu"
								[showMatchModes]="false"
								[showOperator]="false"
								[showAddButton]="false"
								class="ml-auto"
							>
								<ng-template pTemplate="header">
									<div class="px-3 pt-3 pb-0">
										<span class="font-bold">Job</span>
									</div>
								</ng-template>
								<ng-template pTemplate="filter" let-value let-filter="filterCallback">
									<p-multiSelect
										[ngModel]="value"
										[options]="jobList"
										optionValue="value"
										optionLabel="label"
										placeholder="Any"
										(onChange)="filter($event.value)"
									>
										<ng-template let-option pTemplate="item">
											<div class="p-multiselect-representative-option">
												<span class="ml-1">{{ option.label }}</span>
											</div>
										</ng-template>
									</p-multiSelect>
								</ng-template>
							</p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="hoursWorkedStart">
					<div class="d-flex w-100">
						Hours Worked
						<p-sortIcon field="hoursWorkedStart"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="numeric" field="hoursWorkedStart" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="active">
					<div class="d-flex w-100">
						Enabled
						<p-sortIcon field="active"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="boolean" field="active" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
				<th pSortableColumn="timecardIdHistory.length">
					<div class="d-flex w-100">
						Messages sent (last message)
						<p-sortIcon field="field"></p-sortIcon>
						<div class="ms-auto">
							<p-columnFilter type="numeric" field="timecardIdHistory.length" display="menu" class="ms-auto"></p-columnFilter>
						</div>
					</div>
				</th>
			</tr>
		</ng-template>
		<ng-template let-rec pTemplate="body">
			<tr (click)="selectMessage(rec)">
				<td>{{ rec.subjectEnglish }}</td>
				<td>{{ rec.jobName }}</td>
				<td>{{ rec.hoursWorkedStart }} to {{ rec.hoursWorkedEnd }}</td>
				<td class="d-flex">
					<p-checkbox styleClass="mx-auto" [(ngModel)]="rec.active" [binary]="true"></p-checkbox>
				</td>
				<td>
					{{ rec.timecardIdHistory.length }}
					<span *ngIf="rec.timecardIdHistory.length > 0">
						({{ app.moment(rec.timecardIdHistory[rec.timecardIdHistory.length - 1].datetime).format('L LT') }})
					</span>
				</td>

				<td></td>
			</tr>
		</ng-template>
	</p-table>
</div>
